<template>
    <div v-if="fixprice.length != 0">
    <h2 class="text-center">Самая низкая стоимость ремонта</h2>
    <div class="form-group" v-for="(fp, fk) in fixprice" :key="fk" v-if="fp.name&&fp.name!=='null'">
        <div :data-id="fk">
            <input name="id" type="hidden" :value="fk">
            <input name="name" type="hidden" :value="fp.name">
            <input name="price" type="hidden" :value="fp.price">
            <div class="row row1">
                <div class="col-xs-36" style="font-size: 17px;font-family: 'OpenSansBold', sans-serif;">{{fp.name}}</div>
                <div class="col-xs-12" style="font-size: 21px;font-family: 'OpenSansBold', sans-serif;color: #1f8cc8;">{{fp.price}} {{city.valute}}</div>
                <div class="col-xs-24"><div class="field">
                    <select name="services" class="form-control" v-model="fixprice[fk].service">
                        <option v-for="(v,k) in fp.services" :key="k" :value="k">{{v}}</option>
                    </select>
                </div></div>
                <div class="col-xs-22 toggle_order_button" @click="showFp(fk)" :data-id="fk" style="display: inline-block;cursor:pointer;font-family: 'OpenSansBold', sans-serif;color: #fff;text-transform: uppercase;padding: 5px;border-radius: 4px;background-image: linear-gradient(to top, #356098 0%, #477bbf 100%);border: none;text-align: center;">Моментальная запись</div>
                <a href="#want-price" style="display:none;font-family: 'OpenSansBold', sans-serif;color: #000;text-transform: uppercase;padding: 3px;border-radius: 4px;text-align: center;margin-left: 15px;border: 2px solid black;text-decoration:none;" class="col-xs-10">еще</a>
            </div>
            <div class="toggle_order" v-if="fp.show">
                <div class="row">
                    <div class="col-xs-30"><div class="field">
                        <select  title="Марка" name="brand" class="select2"></select>
                    </div></div>
                    <div class="col-xs-30" v-if="fp.cat_id === 167 || fp.cat_id === 169">
                        <div class="field">
                            <input name="address" type="text" placeholder="Адрес подачи">
                        </div>
                    </div>
                    <div class="col-xs-30" v-else>
                        <div class="field select-models">
                            <select title="Модель" name="model" disabled class="select2"></select>
                        </div>
                    </div>
                    <div class="col-xs-30">
                        <div class="field">
                            <input name="client_name" class="form-control"  v-model="user.name" placeholder="Ваше имя" type="text">
                        </div>
                    </div>
                    <div class="col-xs-30">
                        <div class="field">
                            <input name="phone" class="form-control" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" v-model="user.phone"  type="tel">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-120 text-center">
                        <div class="time">
                            <span v-if="fp.job_id == 167 || fp.job_id == 169">Эвакуатор нужен на</span>
                            <span v-else>Мне удобно посетить сервис</span>
                            <input name="date" id="date_c" type="date" v-model="date">
                            <span>в</span>
                            <input name="time" type="time" v-model="time">
                        </div>
                        <div class="get-offer">
                            <button @click="sendLead(fk)">Записаться</button>
                        </div>
                        <div class="error alert alert-danger" v-if="errors.length > 0">
                            <p v-for="(error, index) in errors" :key="index">{{error}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
import Inputmask from 'inputmask'
export default {
  name: 'FixPrices',
  props: ['city', 'user', 'auth', 'fixprice'],
  data () {
    return {
      brands: [],
      marks: [],
      errors: [],
      date: '',
      time: ''
    }
  },
  created () {
  },
  methods: {
    showFp (id) {
      console.log(id)
      for (var fk in this.fixprice) {
        console.log(fk)
        console.log(this.fixprice[fk])
        if (id !== fk) this.fixprice[fk].show = 0
        else this.fixprice[fk].show = !this.fixprice[fk].show
        console.log(this.fixprice[fk])
      }
    },
    sendLead (fk) {
      this.errors = []
      console.log(this.fixprice[fk])
      if (!this.user.phone) this.errors.push('Вам необходимо указать телефон')
      if (!this.fixprice[fk].service) this.errors.push('Вам необходимо выбрать автосервис')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        var notes = []
        notes.push('Категория работ: ' + this.fixprice[fk].cat)
        notes.push('Вид работ: ' + this.fixprice[fk].job)
        notes.push('Выбрана фиксированная цена, сервис и стоимость проставлены автоматически')
        if (this.date || this.time) notes.push('Дата время записи: ' + this.date + ' ' + this.time)
        formData.append('crm', '1')
        formData.append('pipe', '1')
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        formData.append('contact[45]', this.city.name)
        formData.append('lead[5]', this.brands[this.user.mark])
        formData.append('lead[price]', this.fixprice[fk].price)
        formData.append('lead[41]', this.fixprice[fk].service)
        formData.append('lead[6]', this.marks[this.user.model])
        formData.append('lead[69]', this.user.uid)
        formData.append('lead[36]', this.city.name)
        formData.append('lead[43]', this.date + ' ' + this.time)
        formData.append('lead[40]', (this.fixprice[fk].job_id ? this.fixprice[fk].job_id : this.fixprice[fk].cat_id))
        formData.append('note', notes.join('<br>'))
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  },
  updated () {
    var $this = this
    $('[name="brand"]').select2({
      placeholder: 'Выберите Марку',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-marks',
        dataType: 'json',
        processResults: function (data) {
          let res = $.map(data, function (item) {
            $this.brands[item.id] = item.name
            return {
              text: item.name,
              id: item.id
            }
          })
          return {
            results: res
          }
        }
      }
    }).change(function (data) {
      $this.user.mark = $(this).val()
      $('[name="model"]').val(null).trigger('change').prop('disabled', false)
    })

    $('[name="model"]').select2({
      placeholder: 'Выберите Модель',
      ajax: {
        delay: 250,
        type: 'POST',
        data: function (params) {
          params.brend_id = $this.user.mark
          params.q = params.term
          return params
        },
        url: 'https://crm.v-avtoservice.com/list/site-get-models',
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.marks[item.id] = item.name
              return {
                text: item.name,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.user.model = $(this).val()
    })

    Inputmask().mask(document.querySelectorAll('input'))
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/FixPrices.vue